<template>
  <div class="big">
    <div class="page_title">推荐商品规则</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
              :disabled="module_id_array[0] ? !module_id_array.includes('892') : false"
            >直接推荐</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
              :disabled="module_id_array[0] ? !module_id_array.includes('893') : false"
            >诊断关键词</el-menu-item>
            <el-menu-item
              index="3"
              style="font-size:16px"
              :disabled="module_id_array[0] ? !module_id_array.includes('893') : false"
            >擅长方向</el-menu-item>
            <el-menu-item
              index="4"
              style="font-size:16px"
              :disabled="module_id_array[0] ? !module_id_array.includes('893') : false"
            >科室</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Direct from './Direct.vue';
import Diagnosis from './Diagnosis.vue';
import BeGoodAt from './BeGoodAt.vue';
import Department from './Department.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '1'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return Direct;
        case '2':
          return Diagnosis;
        case '3':
          return BeGoodAt;
        case '4':
          return Department;
        default:
          return Direct;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    handleSelect(key) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
